var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSelected)?_c('span',[_c('font-awesome-icon',{staticClass:"fa-fw",attrs:{"icon":['fas', 'check']}})],1):_c('span',[_c('font-awesome-icon',{staticClass:"fa-fw",attrs:{"icon":['fas', 'plus']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }